module.exports = __webpack_public_path__ + "img/homeBg.8557d42b.png";